import { render, staticRenderFns } from "./en-sentenceAddPage.vue?vue&type=template&id=bf8e9e2a&scoped=true&"
import script from "./en-sentenceAddPage.vue?vue&type=script&lang=js&"
export * from "./en-sentenceAddPage.vue?vue&type=script&lang=js&"
import style0 from "./en-sentenceAddPage.vue?vue&type=style&index=0&id=bf8e9e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8e9e2a",
  null
  
)

export default component.exports